import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import DrinksMenu from "@/components/DrinksMenu";
import Cleanses from "@/components/Cleanses";
import Story from "@/components/Story";
import GiftCard from "@/components/GiftCard";
import Testimonials from "@/components/Testimonials";
import SqueezeClub from "@/components/SqueezeClub";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-cream font-sans text-ink antialiased">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <DrinksMenu />
        <Cleanses />
        <Story />
        <GiftCard />
        <Testimonials />
        <SqueezeClub />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}

export default App;
